import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtohonnavarcabservice() {



    const cardData = {




keyword: "Belgaum to Honnavar Cab Service",

headingDescription: "Belgaum Taxi Service provides comfortable, safe, and reliable Belgaum to Honnavar cab services for coastal travel, family trips, pilgrimage journeys, business visits, and outstation transportation. We offer one-way taxi, round-trip cab, and customized travel options from Belgaum to Honnavar with professional drivers and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars suitable for individuals, families, and groups. With doorstep pickup, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support, we ensure a smooth and comfortable journey between Belgaum and Honnavar. Whether you are planning a beach holiday, temple visit, Karnataka coastal tour, family vacation, or personal travel, Belgaum Taxi Service provides dependable cab solutions with experienced chauffeurs, clean vehicles, and safe highway travel for a hassle-free experience.",

topPlaces: [
  {
    title: "Honnavar",
    description: "Honnavar is a beautiful coastal town in Karnataka known for its scenic beaches, rivers, forests, temples, and natural landscapes. Located along the Arabian Sea coast, it is a peaceful destination for travelers looking to explore coastal Karnataka. The town is also an important stop connecting several famous beaches, waterfalls, and heritage attractions."
  },
  {
    title: "Apsarakonda Waterfall",
    description: "Apsarakonda Waterfall is one of Honnavar's most attractive natural destinations, known for its beautiful waterfall, green surroundings, beach views, and peaceful atmosphere. It is a perfect place for families, nature lovers, and photographers looking for a relaxing experience."
  },
  {
    title: "Eco Beach Honnavar",
    description: "Eco Beach is a clean and scenic beach destination near Honnavar known for its peaceful environment, golden sands, and beautiful coastal views. It is suitable for visitors who want to enjoy nature away from crowded tourist places."
  },
  {
    title: "Sharavathi River",
    description: "Sharavathi River is one of Karnataka's important rivers and adds natural beauty to Honnavar. The river surroundings offer scenic views, boating opportunities, and a peaceful environment for travelers exploring the coastal region."
  },
  {
    title: "Murudeshwar",
    description: "Murudeshwar is a famous coastal pilgrimage destination near Honnavar known for the giant Shiva statue, Murudeshwar Temple, beautiful beaches, and Arabian Sea views. Many travelers combine Honnavar and Murudeshwar during coastal Karnataka trips."
  },
  {
    title: "Gokarna",
    description: "Gokarna is a popular beach and pilgrimage destination known for Mahabaleshwar Temple, Om Beach, Kudle Beach, and scenic coastal landscapes. It is a preferred destination for pilgrims, families, couples, and beach lovers."
  },
  {
    title: "Yana Caves",
    "description": "Yana Caves is a unique natural attraction near Honnavar famous for massive black limestone formations, dense forests, trekking routes, and peaceful surroundings. It is a popular destination for adventure enthusiasts and nature lovers."
  },
  {
    title: "Jog Falls",
    "description": "Jog Falls is one of India's highest waterfalls and a major tourist attraction in Karnataka. Surrounded by greenery and hills, it offers breathtaking views and is a popular destination for family trips, photography, and nature exploration."
  },
  {
    title: "Karwar",
    "description": "Karwar is a scenic coastal city known for beaches, islands, natural beauty, and peaceful surroundings. It is an ideal destination for travelers looking for a relaxed coastal holiday experience in Karnataka."
  },
  {
    title: "Goa",
    "description": "Goa is one of India's most popular tourist destinations, famous for beaches, resorts, churches, nightlife, water sports, and coastal attractions. Travelers often combine Honnavar with Goa for an extended coastal road trip."
  }
],




 "services": [
    {
      "name": "Belgaum to Honnavar Cab Service",
      "description": "Book Belgaum to Honnavar Cab Service for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Get Sedan, Ertiga, Innova Crysta, and SUV cab options for family trips, business travel, and convenient journeys between Belgaum and Honnavar with flexible one way and round trip booking facilities."
    },
    {
      "name": "Belgaum to Honnavar Cab",
      "description": "Hire Belgaum to Honnavar Cab service for a smooth and hassle-free journey with experienced drivers, clean vehicles, and affordable travel packages. Our cabs provide comfortable transportation for personal trips, family tours, corporate travel, and long-distance travel requirements."
    },
    {
      "name": "Belgaum to Honnavar Taxi",
      "description": "Choose Belgaum to Honnavar Taxi for reliable intercity transportation with professional drivers, transparent pricing, and multiple vehicle options. Travel comfortably with Sedan, Ertiga, and Innova Crysta taxis available for one way and round trip journeys."
    },
    {
      "name": "Belgaum to Honnavar Taxi Service",
      "description": "Get Belgaum to Honnavar Taxi Service with comfortable AC cars, professional drivers, affordable fares, and flexible booking options. Enjoy a safe and convenient journey from Belgaum to Honnavar for business, personal, and family travel."
    },
    {
      "name": "Belgaum to Honnavar One Way Cab",
      "description": "Book Belgaum to Honnavar One Way Cab for economical single-trip travel without return charges. Enjoy fixed pricing, comfortable seating, clean vehicles, and reliable chauffeur services for your one way journey."
    },
    {
      "name": "Belgaum to Honnavar One Way Taxi",
      "description": "Choose Belgaum to Honnavar One Way Taxi for affordable and convenient transportation with professional drivers and flexible pickup options. Perfect for passengers looking for budget-friendly one direction travel solutions."
    },
    {
      "name": "Belgaum to Honnavar Cab Booking",
      "description": "Complete Belgaum to Honnavar Cab Booking online with easy reservations, quick confirmation, and multiple vehicle choices. Select from Sedan, Ertiga, Innova Crysta, and premium cabs according to your travel requirements."
    },
    {
      "name": "Belgaum to Honnavar Taxi Booking",
      "description": "Reserve Belgaum to Honnavar Taxi Booking services for comfortable and reliable travel with experienced chauffeurs. Get affordable taxi options with flexible schedules for local, family, and corporate journeys."
    },
    {
      "name": "Belgaum to Honnavar Car Rental",
      "description": "Choose Belgaum to Honnavar Car Rental for private chauffeur-driven vehicles with comfortable seating and professional service. Ideal for business trips, family travel, sightseeing, and outstation transportation."
    },
    {
      "name": "Belgaum to Honnavar Outstation Cab",
      "description": "Hire Belgaum to Honnavar Outstation Cab for safe and comfortable long-distance travel. Enjoy reliable transportation with AC vehicles, skilled drivers, transparent fares, and flexible one way or round trip packages."
    },
    {
      "name": "Belgaum to Honnavar Innova Crysta Cab",
      "description": "Book Belgaum to Honnavar Innova Crysta Cab for premium and spacious travel with luxury seating, large luggage capacity, and experienced chauffeurs. Perfect for family groups, corporate travel, and comfortable outstation journeys."
    },
    {
      "name": "Belgaum to Honnavar Ertiga Cab",
      "description": "Choose Belgaum to Honnavar Ertiga Cab for affordable 6 to 7 seater travel with spacious interiors and comfortable seating. Ideal for family trips, airport transfers, and long-distance journeys."
    },
    {
      "name": "Belgaum to Honnavar Sedan Cab",
      "description": "Book Belgaum to Honnavar Sedan Cab for economical and comfortable travel with clean AC vehicles and professional drivers. Suitable for individuals, couples, business trips, and smooth highway journeys."
    },
    {
      "name": "Belgaum to Honnavar Round Trip Cab",
      "description": "Hire Belgaum to Honnavar Round Trip Cab for convenient return journeys with affordable packages and flexible travel schedules. Perfect for family visits, sightseeing, weekend trips, and personal travel."
    },
    {
      "name": "Belgaum to Honnavar Private Taxi",
      "description": "Reserve Belgaum to Honnavar Private Taxi for a personalized travel experience with dedicated vehicles and professional chauffeurs. Enjoy privacy, comfort, and hassle-free transportation throughout your journey."
    },
    {
      "name": "Cheap Belgaum to Honnavar Cab",
      "description": "Find Cheap Belgaum to Honnavar Cab services offering affordable fares without compromising safety and comfort. Get reliable vehicles, experienced drivers, and budget-friendly travel solutions."
    },
    {
      "name": "Best Belgaum to Honnavar Cab Service",
      "description": "Choose the Best Belgaum to Honnavar Cab Service with premium vehicles, trained drivers, competitive pricing, and dependable customer support. Experience smooth and comfortable travel for all types of journeys."
    },
    {
      "name": "Online Belgaum to Honnavar Cab Booking",
      "description": "Complete Online Belgaum to Honnavar Cab Booking with simple reservations, instant confirmation, and flexible travel options. Select your preferred vehicle and enjoy convenient doorstep pickup service."
    },
    {
      "name": "Belgaum to Honnavar Taxi Fare",
      "description": "Check Belgaum to Honnavar Taxi Fare for affordable and transparent pricing with no hidden charges. Get comfortable cabs with professional drivers for safe and economical travel."
    },
    {
      "name": "Belgaum to Honnavar Car Hire",
      "description": "Hire Belgaum to Honnavar Car Hire services for comfortable private travel with chauffeur-driven vehicles. Choose from multiple car categories for personal, family, and corporate transportation needs."
    },
    {
      "name": "Belgaum to Honnavar Cab Price",
      "description": "Get affordable Belgaum to Honnavar Cab Price with flexible packages for one way and round trips. Enjoy quality vehicles, reliable service, and professional drivers at competitive rates."
    },
    {
      "name": "Belgaum to Honnavar Family Cab",
      "description": "Book Belgaum to Honnavar Family Cab for safe and comfortable family travel with spacious vehicles and experienced chauffeurs. Perfect for vacations, family functions, and personal visits."
    },
    {
      "name": "Belgaum to Honnavar Corporate Taxi",
      "description": "Choose Belgaum to Honnavar Corporate Taxi services for business travel and executive journeys. Get punctual service with professional drivers and well-maintained vehicles."
    },
    {
      "name": "Belgaum to Honnavar Airport Transfer",
      "description": "Book Belgaum to Honnavar Airport Transfer services for timely airport pickup and drop with comfortable vehicles and professional chauffeurs. Enjoy stress-free airport transportation with reliable cab availability."
    },
    {
      "name": "Belgaum to Honnavar Cab Fare",
      "description": "Get the best Belgaum to Honnavar Cab Fare with affordable travel packages and transparent pricing. Travel comfortably with Sedan, Ertiga, Innova Crysta, and SUV cab options."
    },
    {
      "name": "Belgaum to Honnavar Taxi Near Me",
      "description": "Find Belgaum to Honnavar Taxi Near Me for quick and reliable cab availability with professional drivers. Enjoy convenient booking, doorstep pickup, and comfortable travel anytime."
    },
    {
      "name": "Belgaum to Honnavar Outstation Taxi",
      "description": "Book Belgaum to Honnavar Outstation Taxi for safe and convenient long-distance travel. Get clean AC vehicles, experienced chauffeurs, and flexible travel plans for personal and business journeys."
    },
    {
      "name": "Belgaum to Honnavar Travel by Cab",
      "description": "Experience comfortable Belgaum to Honnavar Travel by Cab with reliable transportation, professional drivers, and premium vehicle options. Enjoy a smooth journey with convenient pickup and customized travel solutions."
    }
  ],
  "tableData": [
    ["Belgaum to Honnavar Cab Service", "Belgaum to Honnavar Cab"],
    ["Belgaum to Honnavar Taxi", "Belgaum to Honnavar Taxi Service"],
    ["Belgaum to Honnavar One Way Cab", "Belgaum to Honnavar One Way Taxi"],
    ["Belgaum to Honnavar Cab Booking", "Belgaum to Honnavar Taxi Booking"],
    ["Belgaum to Honnavar Car Rental", "Belgaum to Honnavar Outstation Cab"],
    ["Belgaum to Honnavar Innova Crysta Cab", "Belgaum to Honnavar Ertiga Cab"],
    ["Belgaum to Honnavar Sedan Cab", "Belgaum to Honnavar Round Trip Cab"],
    ["Belgaum to Honnavar Private Taxi", "Cheap Belgaum to Honnavar Cab"],
    ["Best Belgaum to Honnavar Cab Service", "Online Belgaum to Honnavar Cab Booking"],
    ["Belgaum to Honnavar Taxi Fare", "Belgaum to Honnavar Car Hire"],
    ["Belgaum to Honnavar Cab Price", "Belgaum to Honnavar Family Cab"],
    ["Belgaum to Honnavar Corporate Taxi", "Belgaum to Honnavar Airport Transfer"],
    ["Belgaum to Honnavar Cab Fare", "Belgaum to Honnavar Taxi Near Me"],
    ["Belgaum to Honnavar Outstation Taxi", "Belgaum to Honnavar Travel by Cab"]
  ],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Honnavar Cab Service",
    WhyChoosedescription: "Travel comfortably from Belgaum to Honnavar with a trusted taxi service offering clean vehicles, professional drivers, and convenient travel solutions for coastal journeys."
  },
  {
    WhyChooseheading: "Direct Cab Travel with Doorstep Pickup",
    WhyChoosedescription: "Enjoy a smooth point-to-point journey with pickup from your preferred location in Belgaum and drop service anywhere in Honnavar."
  },
  {
    WhyChooseheading: "Wide Range of Comfortable Vehicles",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs based on your group size, luggage, and travel comfort needs."
  },
  {
    WhyChooseheading: "Ideal for Beach & Family Trips",
    WhyChoosedescription: "Our Belgaum to Honnavar cabs are suitable for coastal holidays, family vacations, temple visits, sightseeing trips, and personal travel requirements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Coastal Routes",
    WhyChoosedescription: "Professional chauffeurs provide safe driving, timely service, and smooth travel with proper knowledge of long-distance routes."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Select a one-way taxi for direct travel or book a round-trip cab according to your preferred schedule and journey plan."
  },
  {
    WhyChooseheading: "Comfortable Cars for Long Distance Travel",
    WhyChoosedescription: "Well-maintained vehicles with clean interiors and spacious seating ensure a relaxing travel experience from Belgaum to Honnavar."
  },
  {
    WhyChooseheading: "Easy Booking & Travel Assistance",
    WhyChoosedescription: "Get support for vehicle selection, fare details, and cab availability to arrange your Belgaum to Honnavar taxi service easily."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Honnavar Cab Service?",
    answer: "Yes, we provide Belgaum to Honnavar cab services with comfortable vehicles and experienced drivers for outstation travel."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Honnavar?",
    answer: "Yes, one-way taxi services are available for passengers who need direct transportation without a return journey."
  },
  {
    question: "Which vehicles are available for Belgaum to Honnavar travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs according to your requirements."
  },
  {
    question: "Is Belgaum to Honnavar cab suitable for family trips?",
    answer: "Yes, spacious and comfortable vehicles are available for families and groups travelling to Honnavar."
  },
  {
    question: "Can I book a return taxi from Honnavar to Belgaum?",
    answer: "Yes, return journey cabs are available with flexible timings based on your travel schedule."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, homes, and other preferred locations."
  },
  {
    question: "Can I include sightseeing during my Honnavar trip?",
    answer: "Yes, sightseeing stops and customized travel plans can be arranged according to your itinerary."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll, parking, and additional travel charges depend on the selected package and are explained during booking."
  },
  {
    question: "Is Belgaum to Honnavar taxi service available anytime?",
    answer: "Yes, taxi booking assistance is available for planned journeys and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Honnavar Cab?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vinay Shetty",
    feedback: "The Belgaum to Honnavar cab service was comfortable and reliable. The driver was experienced, and the vehicle was perfect for our coastal trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shilpa Patil",
    feedback: "We travelled with family and had a wonderful experience. The cab was clean, spacious, and the complete journey was smooth.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Honnavar Cab Service",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-honnavar-cab-service.webp",
  "description":
    "Book Belgaum to Honnavar Cab Service with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Honnavar with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for beach trips, family vacations, business travel, sightseeing tours, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-honnavar-cab-service"
  }
};




    return (
        <div>



<Helmet>
  <title>Belgaum to Honnavar Cab Service | Premium Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Honnavar Cab Service with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs for affordable and comfortable outstation travel from Belgaum to Honnavar with 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Belgaum to Honnavar Cab Service, Belgaum to Honnavar Cab, Belgaum to Honnavar Taxi, Belgaum to Honnavar Taxi Service, Belgaum to Honnavar One Way Cab, Belgaum to Honnavar One Way Taxi, Belgaum to Honnavar Cab Booking, Belgaum to Honnavar Taxi Booking, Belgaum to Honnavar Car Rental, Belgaum to Honnavar Outstation Cab, Belgaum to Honnavar Innova Crysta Cab, Belgaum to Honnavar Ertiga Cab, Belgaum to Honnavar Sedan Cab, Belgaum to Honnavar Round Trip Cab, Best Belgaum to Honnavar Taxi Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/58.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtohonnavarcabservice ;